import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { useAuthStore } from "@/store/AuthStore";

// Create the Vue application instance
const app = createApp(App);
app.use(router);
const pinia = createPinia();
app.use(pinia);
// Extract JWT from URL
const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token");

if (token) {
  const authStore = useAuthStore(); // Get the auth store instance
  authStore.setToken(token); // Store the JWT token
}

/**
 * Guard: Only run the SPA when embedded in an iframe (except local dev).
 * Replaces the body with a message and skips mounting when blocked.
 * @returns boolean Whether the app is allowed to run
 */
function allowEmbeddingOnly(): boolean {
  const isEmbedded = window.top !== window.self;
  const isLocal =
    location.hostname === "localhost" ||
    location.hostname === "127.0.0.1" ||
    location.hostname === "0.0.0.0" ||
    location.protocol === "file:";

  if (!isLocal && !isEmbedded) {
    document.body.innerHTML =
      "<h1>This application must be opened inside GS Hub</h1>";
    return false;
  }
  return true;
}

if (allowEmbeddingOnly()) {
  app.mount("#app"); // Mount only when allowed
}
